<template>
  <div>
    <el-dialog
      title="订单收款记录"
      :visible="isShowDialog"
      width="1000px"
      custom-class="rent-order-dialog"
      :before-close="handleClose"
    >
      <base-list-management v-if="isShowDialog" ref="baseListManagement" :configData.sync="configData"/>
    </el-dialog>
  </div>
</template>
<script>
import configDataFn from './config'

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['orderData'],
  data() {
    const { configData } = configDataFn.call(this)
    return {
      configData,
    }
  },
  methods: {
    handleClose() {
      this.$refs.baseListManagement?.reset()
      this.$emit('closeDialog', false)
    },
    // sourceOrderType来源单类型 2车辆租赁合同/7逾期应收单/100其他
    // ./config文件里有使用
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      val.sourceOrderId = this.orderData.id
      val.sourceOrderType = 2
      return val
    },
    // 跳转查看详情
    // ./config文件里有使用
    // eslint-disable-next-line vue/no-unused-properties
    viewDetail({ id }) {
      this.$router.push({
        path: '/workbench/order/collection/detail',
        query: { type: 'order', id: String(id), rentOrderId: this.orderData.id }, // todo
      })
    },
  },
}
</script>
